import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { getAllStoreTypeForSelect } from "pages/Components/API_Modal";
import { HttpStatus } from "modules/core";
import notistack from "modules/core/notistack";

interface StoreOption {
    text: string;
    value: string;
    disabled: boolean;
    selected: boolean;
    isMayaveStore?: boolean;
}

interface StoreSelectOptionsProps {
    onStoreChange?: (value: string) => void; // new prop
}

const StoreSelectOptions: React.FC<StoreSelectOptionsProps> = ({ onStoreChange }) => {
    const [storeOptions, setStoreOptions] = useState<StoreOption[]>([]);
    const [selectedStore, setSelectedStore] = useState<string | undefined>(undefined);

    useEffect(() => {
        getAllStoreData();
    }, []);

    const getAllStoreData = async () => {
        try {
            let storeList;
            const response = await getAllStoreTypeForSelect();
            if (response?.status === HttpStatus.Success) {
                storeList = response?.data || [];
                const firstStoreValue = storeList[0].value;
                const authUserString = localStorage.getItem("authPOSUser");
                const storedStoreId = localStorage.getItem("storedataid");
                let matchedStore;

                if (storedStoreId) {
                    matchedStore = storeList.find((store: any) => store.value === storedStoreId);
                }

                if (authUserString) {
                    if (storedStoreId && matchedStore) {
                        setSelectedStore(storedStoreId);
                    } else {
                        setSelectedStore(storeList[0]?.value)
                    }
                }
                setStoreOptions(storeList);
                if (onStoreChange) {
                    onStoreChange(firstStoreValue);
                }
            }
            else {
                notistack.notifyFromApi(response)
            }

        } catch (error) {
            console.error("Error fetching store:", error);
        }
    };


    const handleStoreChange = (value: string) => {
        setSelectedStore(value);
        if (onStoreChange) {
            onStoreChange(value);
        }
    };


    const isMainStore = localStorage.getItem('isMainStore')

    return (
        <>
            {isMainStore === 'true' && (
                <>
                    <span className="fw-bold">Store Code</span> <br />
                    <Select
                        showSearch
                        placeholder="Select Store"
                        optionFilterProp="label"
                        value={selectedStore}
                        onChange={handleStoreChange}
                        options={storeOptions.map((store) => ({
                            label: store.text,
                            value: store.value,
                            disabled: store.disabled,
                        }))}
                        style={{ width: "15em" }}
                        filterOption={(input, option) =>
                            (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                        }
                        getPopupContainer={(trigger) => trigger.parentElement}
                    />
                </>
            )}

        </>
    );
};

export default StoreSelectOptions;
